import axios from "@/axios.js";

// Liens « catalogue PDF » et « fiches techniques » du mail d'envoi de devis,
// places juste apres « Vous trouverez ci-joint votre devis #… ». Les URL sont en
// base (table quotation_mail_link, une ligne par langue, modifiable dans
// Settings -> Quote Email Links) : le nom du PDF change a chaque mise a jour du
// catalogue sur Wix.
//
// Langue client sans ligne -> liens anglais. Lien sans URL http(s) ou sans
// texte -> omis.

const FALLBACK_LANG = "en";

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/** Ligne a utiliser pour une langue client ('fr', 'nl', …), repli anglais. */
export function pickQuotationMailLinks(rows, language) {
  const lang = String(language || "").substring(0, 2).toLowerCase();
  const list = Array.isArray(rows) ? rows : [];
  return list.find(r => r.lang === lang) || list.find(r => r.lang === FALLBACK_LANG) || null;
}

/** HTML des liens, precede d'un saut de paragraphe ; '' si aucun lien. */
export function buildQuotationMailLinksHtml(row) {
  if (!row) return "";
  const links = [
    [row.catalogue_url, row.catalogue_label],
    [row.datasheet_url, row.datasheet_label],
  ]
    .filter(([url, label]) => label && /^https?:\/\//i.test(url || ""))
    .map(([url, label]) =>
      `<a href="${escapeHtml(url)}" target="_blank" style="color: #0073b1;">${escapeHtml(label)}</a>`
    );
  return links.length ? "<br/><br/>" + links.join("<br/>") : "";
}

/**
 * @param {string} language  code langue de la fiche contact
 * @returns {Promise<string>} HTML a inserer dans le message ; '' en cas d'erreur
 *          (le devis part alors sans les liens, l'apercu le montre).
 */
export async function getQuotationMailLinksHtml(language) {
  try {
    const { data } = await axios.get("/quotation-mail-links");
    return buildQuotationMailLinksHtml(pickQuotationMailLinks(data, language));
  } catch (error) {
    console.error("Error fetching quote email links:", error);
    return "";
  }
}
